// Network delivery order is independent of the order in which messages were saved.
// Keep microseconds: a user message and its reply can be created in the same millisecond.
function timestamp(value) {
  const milliseconds = Date.parse(value)
  if (!Number.isFinite(milliseconds)) return null
  const fraction = value.match(/\.(\d+)/)?.[1] || ""
  return Math.floor(milliseconds / 1000) * 1_000_000 + Number(fraction.slice(0, 6).padEnd(6, "0"))
}

export function orderMessages(container) {
  if (!container) return

  const byId = new Map()
  for (const root of Array.from(container.children)) {
    // Participant messages have a turbo-frame wrapper; facilitator messages do not.
    const message = root.matches("[data-message-id]") ? root : root.querySelector("[data-message-id]")
    if (!message) continue
    const createdAt = timestamp(message.dataset.createdAt)
    if (createdAt === null) continue

    const entry = { root, message, createdAt, id: message.dataset.messageId }
    const existing = byId.get(entry.id)
    if (existing) {
      // The HTTP response and broadcast can both deliver the same message.
      // A late placeholder must not replace an already completed response.
      if (existing.message.dataset.complete === "true" && message.dataset.complete !== "true") {
        root.remove()
        continue
      }
      existing.root.remove()
    }
    byId.set(entry.id, entry)
  }

  // Replacing a duplicate can change its position even though Map keeps the
  // original insertion order. Read the surviving roots in their actual DOM order.
  const entries = Array.from(container.children).flatMap(root => {
    const message = root.matches("[data-message-id]") ? root : root.querySelector("[data-message-id]")
    const entry = message && byId.get(message.dataset.messageId)
    return entry?.root === root ? [entry] : []
  })
  const ordered = entries.slice().sort((left, right) =>
    left.createdAt - right.createdAt || (left.id < right.id ? -1 : left.id > right.id ? 1 : 0)
  )
  for (let index = 0; index < ordered.length; index += 1) {
    if (entries[index] === ordered[index]) continue
    const from = entries.indexOf(ordered[index], index)
    container.insertBefore(ordered[index].root, entries[index].root)
    entries.splice(index, 0, entries.splice(from, 1)[0])
  }
}
